import React, { useState, useContext } from 'react';
import { SettingsContext, TranslationContext } from './Context';

const GridItemBuyArea = props => {

    const settings = useContext(SettingsContext);
    const translations = useContext(TranslationContext);
    const [showMessage, setShowMessage] = useState(false);

    const callAddToCart = () => {
        props.addToCart();
        setShowMessage(true);

        setTimeout(() => {
            setShowMessage(false);
        }, 3000);
    };
    
    return (
        <>
            <div className="variantPickerComponent-productFooter">
                <div className="variantPickerComponent-productPrice">{props.price.commerceData.givenPrice}</div>

                {
                    props.buyable &&
                    <span className="">{props.price?.commerceData?.stockText}</span>
                }
                {
                    props.displayLowStockVerbiage &&
                    <div class="lowstockverbiage u-dFlex u-floatright">
                        <div><svg height="8" width="8" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 8"><circle cx="4.5" cy="4" r="4" fill="#F89D4A"></circle></svg>
                        </div>
                        <div>|</div>
                        <div>{translations["LowInventoryVerbiage"]}</div>
                    </div>
                }
            </div>

            {settings.renderAddToCart && <button className="variantPickerComponent-productCta btn btn-primary" disabled={!props.buyable} onClick={callAddToCart} type="button" >{translations["VariantPicker.AddToCart"]}</button>}
            {showMessage && <div className="u-absTopMarginSm u-textRegular14">Added to cart! <a href={settings.cartUrl}>View cart</a></div>}
        </>
    );
};

export default GridItemBuyArea;